import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import { SEARCH_PARAM_WALKDOWN_ID } from 'routes/walkdowns/-searchParams'
import { Route as NewRoute } from 'routes/walkdowns/details'

export const Route = createFileRoute(
  '/walkdowns/(deprecated_routes)/$siteID/$walkdownId'
)({
  beforeLoad: ({ params }) => {
    const { siteID, walkdownId } = params

    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_SITE_ID]: siteID,
        [SEARCH_PARAM_WALKDOWN_ID]: walkdownId,
      }),
      replace: true,
    })
  },
})
